// Remplace la page « Membres » de l'administration (08/10) : les comptes se gèrent dans
// l'application (front/lib/compta/administration_membres.ts).
import { t } from "@app/lib/compta/i18n";
import { envoyer } from "@app/lib/compta/navigation_app";
import { Button, Page } from "@dust-tt/sparkle";

export function MembresGeresParLApp() {
  return (
    <Page.Vertical gap="lg" align="stretch">
      <Page.Header title={t("Team accounts are managed in the application")} />
      <Page.P>
        {t(
          "Open the application settings, Comptes tab, to add a member, change a role or remove an account. Changes made here would be replaced by the application."
        )}
      </Page.P>
      <div>
        <Button
          label={t("Open the settings")}
          variant="primary"
          onClick={() => envoyer({ type: "compte", action: "reglages" })}
        />
      </div>
    </Page.Vertical>
  );
}
